import React from 'react'

const Ping = (props) => {
  return (
    <p>pong</p>
  );
};

export default Ping;